const init = () => {
    const paidProductOrderFormWrapper = document.querySelector('.order-form--paid')
    const freeProductOrderFormWrapper = document.querySelector('.order-form--free')
    if (!paidProductOrderFormWrapper && !freeProductOrderFormWrapper) return

    const orderForm = document.querySelector('.order-form')
    const buttons = orderForm.querySelectorAll('button')
    let submitButton = null
    buttons.forEach(button => {
        if (button.classList.contains('cart-update-button')) {
            return
        }
        submitButton = button
    })
    if (!submitButton) return
    const productRows = orderForm.querySelectorAll('tr')
    const orderSumRowValue = orderForm.querySelector('.sum-total').textContent
    const orderSum = formatOrderSum(orderSumRowValue)
    let products = []
    submitButton.addEventListener("click", e => {
        let transactionId = (Date.now().toString(10) + Math.random().toString(10)).substring(6, 12)
        productRows.forEach((productRow, i) => {
            if (i < productRows.length - 1) {
                let amountField = productRow.children[1].querySelector('input')
                let idField = productRow.children[1].querySelectorAll('input')[1]
                let categoryField = productRow.children[1].querySelectorAll('input')[2]

                let id = idField.value
                let name = productRow.children[0].textContent
                let amount = amountField.value
                let subtotal = productRow.children[2].textContent
                let price;
                let category = categoryField.value

                if (amount !== '0') {
                    price = `${parseFloat(subtotal).toFixed(2) / parseFloat(amount).toFixed(2)}.00`
                    if (parseInt(price) < 10) {
                        price = `0${price}`
                    }
                } else {
                    price = '00.00'
                }

                let product = {
                    name,
                    id,
                    price,
                    category,
                    'quantity': amount
                }
                products.push(product)
            }
        })

        const validationFail = orderForm.querySelector(
            '.ValidationFail')
        let isValid = !!!validationFail

        isValid ? dataLayer.push({
            'event': "transaction",
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': transactionId,
                        'revenue': orderSum,
                    },
                    'products': products,
                    'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
                    'selectedBranch': getBranchName()
                }
            }

        }) : null
    })

    function formatOrderSum(inputValue) {
        if (!inputValue) return
        let inputArr = inputValue.split(' ')
        let input = inputArr[0]
        if (input === '0') return
        let output = parseFloat(input).toFixed(2)
        if (output < 10) {
            output = `0${output}`
        }
        return output
    }
    function getBranchName() {
        const branchBtn = document.querySelector('.branch__open');
        if (!branchBtn) return
        let branchName = branchBtn.innerText
        let arr = branchName.split(" ")
        let isBranch = arr.includes("BRANSCH")

        return isBranch ? null : branchName.charAt(0).toUpperCase() + branchName.slice(1).toLowerCase()
    }
}

document.addEventListener("DOMContentLoaded", () => init())
